import env from '../config/env.js';

/**
 * Função utilitária para gerar os headers padrão com autenticação
 * @param {string} token - Token de autenticação (opcional)
 * @returns {Object} Headers configurados
 */
export const getHeaders = (token = null) => {
  const headers = {
    'Content-Type': 'application/json',
    'x-second-key': env.SECOND_SECRET_KEY
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      headers['Authorization'] = `Bearer ${storedToken}`;
    }
  }

  return headers;
};

/**
 * Função utilitária para gerar headers sem Content-Type (para uploads)
 * @param {string} token - Token de autenticação (opcional)
 * @returns {Object} Headers configurados
 */
export const getHeadersWithoutContentType = (token = null) => {
  const headers = {
    'x-second-key': env.SECOND_SECRET_KEY
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      headers['Authorization'] = `Bearer ${storedToken}`;
    }
  }

  return headers;
};
